import { render, staticRenderFns } from "./todaySummary.vue?vue&type=template&id=2edce22c&scoped=true&"
import script from "./todaySummary.vue?vue&type=script&lang=js&"
export * from "./todaySummary.vue?vue&type=script&lang=js&"
import style0 from "./todaySummary.vue?vue&type=style&index=0&id=2edce22c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edce22c",
  null
  
)

export default component.exports